import { Vue, i18n } from 'Common/vue';

import '../layouts/default';

// import components
import Comparison from './../components/vue/Comparison.vue';

window.$_comparison = new Vue({
    i18n,
    render: h => h(Comparison)
}).$mount("#comparison");

rEvent.on('Comparison.countUpdated', (data) => {
    document.querySelector('.js-comparison-count').innerHTML = `(${data.count})`;
});

rEvent.on('Cart.fetchedComparisonProducts', () => {
    setTimeout(() => {
        syncscroll.reset();
    }, 250);
});

